/* eslint-disable class-methods-use-this */

import {default as generateUniqueId} from 'nanoid';
import {UniqueIdGeneratorInstanceType} from '../uniqueId/types';

/**
 *  nanoid id lib facade for UniqueIdGenerator interface
 */
class NanoIdGenerator implements UniqueIdGeneratorInstanceType {
    /**
     * Method which returns unique id dependence on size
     * @param {number} size - size of unique id
     * @returns {string} id - unique id
     */
    generateId(size: number) {
        return generateUniqueId(size);
    }
}

export default NanoIdGenerator;
